export default function isAgent(profile: any) {
  if (profile && profile.roles && profile.roles.id === 19) {
    return true
  }
  return false
}
